const beneficiaries = [
  { icon: 'ri-user-heart-line', title: 'Persons with Epilepsy', desc: 'Direct beneficiaries of our support, treatment, and empowerment programs. We walk alongside them every step of the way.', color: 'bg-purple-50 border-purple-100', iconBg: 'bg-[#7B2D8B]/10', iconColor: 'text-[#7B2D8B]' },
  { icon: 'ri-nurse-line', title: 'Medical Professionals', desc: 'Benefiting from specialized training and resources to enhance their epilepsy management capabilities.', color: 'bg-violet-50 border-violet-100', iconBg: 'bg-violet-500/10', iconColor: 'text-violet-600' },
  { icon: 'ri-community-line', title: 'Affected Communities', desc: 'Empowered to challenge stigma, build supportive environments, and foster inclusion for all members.', color: 'bg-fuchsia-50 border-fuchsia-100', iconBg: 'bg-fuchsia-500/10', iconColor: 'text-fuchsia-600' },
  { icon: 'ri-parent-line', title: 'Caregivers & Families', desc: 'Receiving guidance, support, and resources to better assist their loved ones living with epilepsy.', color: 'bg-purple-50 border-purple-100', iconBg: 'bg-[#7B2D8B]/10', iconColor: 'text-[#7B2D8B]' },
  { icon: 'ri-graduation-cap-line', title: 'School Children & Educators', desc: 'Educated to foster understanding and inclusion from a young age, building a more compassionate generation.', color: 'bg-violet-50 border-violet-100', iconBg: 'bg-violet-500/10', iconColor: 'text-violet-600' },
  { icon: 'ri-government-line', title: 'Policymakers & Institutions', desc: 'Engaged to advocate for improved policies, healthcare frameworks, and systemic change across Africa.', color: 'bg-fuchsia-50 border-fuchsia-100', iconBg: 'bg-fuchsia-500/10', iconColor: 'text-fuchsia-600' },
];

export default function BeneficiariesSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-4">
          <span className="text-xs font-semibold uppercase tracking-[4px] text-[#7B2D8B]">Who We Serve</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 text-center mb-4">
          Our Target <span className="text-[#7B2D8B]">Beneficiaries</span>
        </h2>
        <p className="text-gray-500 text-center max-w-xl mx-auto mb-14 leading-relaxed">
          Our initiatives are carefully designed to reach and positively impact a diverse group of stakeholders, ensuring comprehensive support and systemic change.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {beneficiaries.map((b) => (
            <div key={b.title} className={`rounded-2xl p-8 border ${b.color} transition-transform hover:-translate-y-1 duration-200`}>
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${b.iconBg} mb-5`}>
                <i className={`${b.icon} ${b.iconColor} text-2xl`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-3">{b.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
